module.exports = __webpack_public_path__ + "static/img/gen_1.8ec72ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gen_1.png
// module id = t21q
// module chunks = 16